import {Outlet, useLocation} from "react-router-dom";
import {useSession} from "@/components/shop/SessionProvider";
import {useShopSite} from "@/components/shop/ShopSiteProvider";
import {shouldShowShopChrome} from "@/lib/authShell";

function isProductPage(pathname: string) {
  return /^\/p\/\d+/.test(pathname);
}

export function ShopBody() {
  const {pathname} = useLocation();
  const {user, ready} = useSession();
  const {status, ready: siteReady} = useShopSite();
  const showChrome = shouldShowShopChrome(pathname, user, ready, siteReady, status.publicAccess);
  if(!showChrome) return <Outlet />;
  return (
    <div className={`content${isProductPage(pathname) ? " content--pdp" : ""}`}>
      <div className="inside">
        <Outlet />
        <div className="clear" />
      </div>
    </div>
  );
}
